import clsx from 'clsx';
import type { FC } from 'react';

import style from './Placeholder.module.scss';

type PlaceholderProps = {
  className?: string;
  width?: string;
};
const Placeholder: FC<PlaceholderProps> = ({ className, width }) => {
  return <span className={clsx(style['placeholder-glow'], className)} style={{ width }}></span>;
};

export default Placeholder;
